var Handlebars = require('/builds/lp-digital/backbee/toolbar-legacy/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"cloud-placeholder w-100\">\n    <div class=\"cloud-placeholder-content\">\n        <span class=\"ico\">\n            <i class=\"icon icon-image\"></i>\n        </span>\n        <span class=\"label\">"
    + container.escapeExpression((lookupProperty(helpers,"trans")||(depth0 && lookupProperty(depth0,"trans"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"drop_image_label",{"name":"trans","hash":{},"data":data,"loc":{"start":{"line":6,"column":28},"end":{"line":6,"column":58}}}))
    + "</span>\n    </div>\n</div>\n";
},"useData":true});